import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react"
import { baseUrl } from "constant"
import { RootState } from "store/store"
import { handlingErrorResponse } from "utils/HandlingErrorResponse"
import { getAuthToken } from "utils/getAuthToken"
import { IResponseType, IPaginationResponseType, IDeviceByIdResponseType, IGetDeviceDetailParamsType} from "./type"
import { DeviceEndpointConst, deleteDeviceById, getDeviceById } from "./const"
import { IAddEditDeviceType, IDeviceResponsesType, IGetAllDeviceRequestType } from "../types"

export const DeviceApi = createApi({
    reducerPath: "deviceApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['deviceTag'],
    endpoints: (builder) => ({
        GetDeviceList: builder.mutation<IPaginationResponseType<IDeviceResponsesType[]>, IGetAllDeviceRequestType>({
            query: device => ({
                url: DeviceEndpointConst.getDeviceInfo,
                method: 'POST',
                body: device
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'deviceTag', id: 'ListAllDevice' }]
        }),
        AddEditDevice: builder.mutation<IResponseType<string>, IAddEditDeviceType>({
            query: device => ({
                url: DeviceEndpointConst.addEditDeviceInfo,
                method: 'POST',
                body: device.deviceObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'deviceTag', id: 'ListAllDevice' }]
        }),
        GetdeviceIdByDetails: builder.query<IResponseType<IDeviceByIdResponseType>, IGetDeviceDetailParamsType>({
            query: (id) => ({
                url: getDeviceById(id.id),
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'deviceTag', id: 'GetdeviceIdByDetails' }]
        }),
        DeleteDevice: builder.mutation<void, number>({
            query: id => ({
                url: deleteDeviceById(id),
                method: 'DELETE',
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'deviceTag', id: 'ListAllDevice' }]
        }),
    })
})